import cls from "classname"

import "./dotsComponent.less"

const DotsComponent = ({ status }) => {
  return (
    <div className={cls("dot-enrollment", { [status]: status })}>
      <div className={cls("dot-inner", { [status]: status })}></div>
    </div>
  )
}
export default DotsComponent
